CardLabelSelectView = require 'views/label/card-label-select-view'
CardMemberSelectView = require 'views/card/card-member-select-view'
ComposerPosSelectorView = require 'views/card-composer/composer-pos-selector-view'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'

module.exports = class ComposerSelectorMenuView extends View
  viewTitleKey: 'options'

  events:
    'click .js-mem-selector': 'openMemSelector'
    'click .js-label-selector': 'openLabelSelector'
    'click .js-pos-selector': 'openPosSelector'

  render: ->
    view = @

    @$el.html(
      templates.fill(
        'popover_selector_menu'
      )
    )

    @

  openMemSelector: (e) ->
    Util.stop(e)
    PopOver.pushView
      view: CardMemberSelectView
      options: { @model, @modelCache }

  openLabelSelector: (e) ->
    Util.stop(e)
    PopOver.pushView
      view: CardLabelSelectView
      options: { @model, @modelCache, hideOnSelect: false }

  openPosSelector: (e) ->
    Util.stop(e)
    PopOver.pushView
      view: ComposerPosSelectorView
      options: { @model, @modelCache }



// WEBPACK FOOTER //
// ./app/scripts/views/card-composer/composer-selector-menu-view.coffee